import React from "react"

const Icon180Icon = ({ style }) => (
  <svg  style={style} fill="currentColor" viewBox="0 0 22 11">
    <g transform="translate(12.000000, 7.000000) rotate(45.000000) translate(-12.000000, -7.000000) translate(1.000000, -4.000000)">
      <path d="M9.47460938,10.4121094 L10.5878906,11.515625 L5.66601562,16.4375 L10.1875,16.4375 L10.1875,18 L3,18 L3,10.8125 L4.5625,10.8125 L4.5625,15.3339844 L9.47460938,10.4121094 Z M10.8125,3 L18,3 L18,10.1875 L16.4375,10.1875 L16.4375,5.66601562 L11.5253906,10.5878906 L10.4121094,9.47460938 L15.3339844,4.5625 L10.8125,4.5625 L10.8125,3 Z"/>
    </g>
  </svg>
)

export default Icon180Icon



// WEBPACK FOOTER //
// ./src/AtomicComponents/Icons/Icon180Icon.jsx